import { __exports as selectors } from "../../../../../../../_virtual/index5.js";
import { __require as requireTypes } from "./types.js";
import { __require as requireConstructors } from "./constructors.js";
import { __require as requireGuards } from "./guards.js";
var hasRequiredSelectors;
function requireSelectors() {
  if (hasRequiredSelectors) return selectors;
  hasRequiredSelectors = 1;
  (function(exports$1) {
    exports$1.__esModule = true;
    var _types = requireTypes();
    Object.keys(_types).forEach(function(key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports$1 && exports$1[key] === _types[key]) return;
      exports$1[key] = _types[key];
    });
    var _constructors = requireConstructors();
    Object.keys(_constructors).forEach(function(key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports$1 && exports$1[key] === _constructors[key]) return;
      exports$1[key] = _constructors[key];
    });
    var _guards = requireGuards();
    Object.keys(_guards).forEach(function(key) {
      if (key === "default" || key === "__esModule") return;
      if (key in exports$1 && exports$1[key] === _guards[key]) return;
      exports$1[key] = _guards[key];
    });
  })(selectors);
  return selectors;
}
export {
  requireSelectors as __require
};
//# sourceMappingURL=index.js.map
